import { Location } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { ReportContext, ReportDefinition } from '../../report.models';
import { RouteAnalysisTableComponent } from '../route-function-report/route-analysis-report/route-analysis-table.component';
import { VehicleWorkReportApiService } from './vehicle-work-report-api.service';
import { VehicleWorkRow, WorkConfirmation } from './vehicle-work-report.models';
import { VEHICLE_WORK_COLUMNS } from './vehicle-work-report.utils';
declare const $: { confirm(options: WorkConfirmation): void };
@Component({ selector: 'app-vehicle-work-report', templateUrl: './vehicle-work-report.component.html' })
export class VehicleWorkReportComponent implements OnChanges, OnDestroy {
  @Input() context!: ReportContext;
  @Input() definition!: ReportDefinition;
  @ViewChild(RouteAnalysisTableComponent) table?: RouteAnalysisTableComponent;
  rows: VehicleWorkRow[] = [];
  readonly columns = VEHICLE_WORK_COLUMNS;
  loading = false;
  hasError = false;
  errorMessage = '';
  private version = 0;
  private destroyed = false;
  private retryRecalculation = false;
  constructor(private readonly api: VehicleWorkReportApiService, private readonly guard: GurdServiceService,
    private readonly notification: NotificationService, private readonly other: OtherService,
    private readonly router: Router, private readonly location: Location) {}
  get subtitle(): string { return `از تاریخ ${this.context.startDate} الی ${this.context.endDate}`; }
  get tableKey(): string { return `work-${this.context.id}`; }
  ngOnChanges(): void {
    if (!this.context || !this.definition) return;
    ++this.version; this.loading = false; this.rows = []; this.table?.reset();
    void this.loadReport();
  }
  ngOnDestroy(): void { this.destroyed = true; ++this.version; }
  loadReport(): Promise<void> { return this.request(false); }
  retry(): Promise<void> { return this.retryRecalculation ? this.recalculate() : this.loadReport(); }
  confirmRecalculation(): void {
    if (this.loading || this.destroyed) return;
    const version = this.version;
    $.confirm({ title: 'با توجه به زمان‌بر بودن این فرایند، از محاسبهٔ مجدد اطمینان دارید؟', content: 'توصیه: بازهٔ تاریخ را طولانی در نظر نگیرید', type: 'blue',
      buttons: { ok: { text: 'محاسبه', btnClass: 'btn-primary', keys: ['enter'], action: async () => { if (version === this.version && !this.destroyed) await this.recalculate(); } }, cancel: { text: 'لغو' } } });
  }
  recalculate(): Promise<void> { return this.request(true); }
  goBack(): void { this.location.back(); }
  private async request(recalculate: boolean): Promise<void> {
    if (this.loading || this.destroyed) return;
    const version = ++this.version;
    this.retryRecalculation = recalculate; this.loading = true; this.hasError = false; this.errorMessage = '';
    try {
      const user = this.guard.decrypt(localStorage.getItem('ID')!);
      const session = this.guard.decrypt(localStorage.getItem('Session')!);
      const result = recalculate ? await this.api.recalculate(this.context, user, session) : await this.api.load(this.definition, this.context, user, session);
      if (version !== this.version) return;
      if (!Array.isArray(result)) {
        if (result.ISSessionExpired || result.ISessionExpired) {
          this.notification.showError('لطفا وارد سیستم شوید'); this.other.removeLocalStorage();
          void this.router.navigate(['login'], { queryParams: { report: recalculate ? 'RxcsK' : 'WORK' } });
          return;
        }
        this.errorMessage = result.strError || 'محاسبهٔ گزارش با خطا مواجه شد'; this.hasError = true; this.rows = []; return;
      }
      this.rows = result;
    } catch {
      if (version !== this.version) return;
      this.rows = []; this.hasError = true; this.errorMessage = 'اتصال به سرور را بررسی و دوباره تلاش کنید.';
    } finally { if (version === this.version) this.loading = false; }
  }
}
